import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { installSentry } from "./lib/sentry";
import { installAnalytics } from "./lib/track";
import { registerServiceWorker } from "./lib/sw";

installSentry();
installAnalytics();

createRoot(document.getElementById("root")!).render(<App />);

// Reveal the app (and hide the boot overlay defined in index.html) once React
// has committed and the browser has had a chance to paint the styled UI. The
// double rAF waits for a real paint so the overlay never lifts onto an unstyled
// frame. A CSS timeout failsafe in index.html hides the overlay regardless if
// this never runs (e.g. a mount error).
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    document.documentElement.dataset.appReady = "1";
  });
});

registerServiceWorker();
